// --- START OF FILE HourInput.js ---

import React, { useState, useMemo } from 'react';
import { isWeekend, isFrenchHoliday, isFutureDate } from '../../utils/dateUtils';

const HourInput = ({ projectId, date, value, onChange, onBlur, disabled }) => {
  const isWeekendDay = isWeekend(date);
  const isHoliday = isFrenchHoliday(date);
  const isFuture = isFutureDate(date);
  const [focused, setFocused] = useState(false);
  const [localValue, setLocalValue] = useState('');

  let inputClasses = "w-full text-center border rounded p-1";
  let cellClasses = "px-4 py-2";
  
  // Appliquer le fond grisé mais garder l'input actif
  if (isWeekendDay) {
    cellClasses += " bg-gray-100";
    inputClasses += " bg-gray-100";
  } else if (isHoliday) {
    cellClasses += " bg-gray-50";
    inputClasses += " bg-gray-50";
  }
  
  // Désactiver uniquement pour les dates futures ou si explicitement désactivé
  if (disabled || isFuture) {
    inputClasses += " cursor-not-allowed opacity-50";
  }

  // Normalise l'affichage de la valeur
  const displayValue = useMemo(() => {
    if (focused) return localValue;
    if (value === null || value === undefined || value === 0) return '';
    return String(value);
  }, [focused, localValue, value]);

  const commitValue = (raw) => {
    let parsed = parseFloat(String(raw).replace(',', '.'));
    if (isNaN(parsed)) parsed = 0;
    const clamped = Math.max(0, Math.min(24, parsed));
    // Appelle le onChange parent sous forme d'événement synthétique
    if (onChange) onChange({ target: { value: clamped } });
    if (onBlur) onBlur();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === 'Escape') {
      e.preventDefault(); // Empêche le comportement par défaut (ex: soumettre un formulaire)
      e.target.blur();   // Retire le focus de l'input
    }
  };
  
  const handleFocus = () => {
    setFocused(true);
    setLocalValue(value ? String(value) : '');
  };

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlurInternal = () => {
    setFocused(false);
    commitValue(localValue);
  };
  
  return (
    <td className={cellClasses}>
      <input
        type="text"
        inputMode="decimal"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        className={inputClasses}
        value={displayValue}
        onFocus={handleFocus}
        onChange={handleChange}
        onBlur={handleBlurInternal}
        onKeyDown={handleKeyDown} // NOUVEAU : Ajout du gestionnaire onKeyDown
        disabled={disabled || isFuture}
        min="0"
        data-hour-input="1"
        data-project-id={projectId}
        data-date={date.toLocaleDateString('sv-SE')}
        title={isHoliday ? "Jour férié" : isWeekendDay ? "Weekend" : ""}
      />
    </td>
  );
};

export default HourInput;
// --- END OF FILE HourInput.js ---
